import amlawFirms from '../data/amlawFirms.json';

/**
 * Highlights (proofPoints) presentation helpers.
 *
 * The backend Highlights builder (backend/data-processing/utils/legal-highlights.js)
 * caps bullets and appends the Am Law 200 label at ingestion time. These helpers
 * apply the same treatment at render time so profiles that were ingested BEFORE
 * that builder change still show a capped, labelled Highlights list.
 */

const AMLAW_LABEL = '(AmLaw Top 200 Law Firm)';
const AMLAW_LABEL_RE = /\(AmLaw Top 200 Law Firm\)/i;

/** Max Highlights bullets to show (backend orders by priority, so top-N = best). */
export const MAX_HIGHLIGHTS = 5;

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// Am Law 200 canonical firm names, longest-first, precompiled to word-boundary
// regexes so a distinctive firm phrase ("Cooley", "Kirkland & Ellis") matches but
// a substring inside a larger word does not.
const FIRM_MATCHERS: RegExp[] = (amlawFirms as string[]).map(
  (firm) => new RegExp(`(^|[^\\w])${escapeRegExp(firm)}($|[^\\w])`, 'i'),
);

/**
 * Append the Am Law 200 parenthetical to a Highlights bullet that names an Am Law
 * firm, unless the label is already present (re-ingested profiles already carry it).
 */
export function decorateAmlawBullet(bullet: string): string {
  if (!bullet || AMLAW_LABEL_RE.test(bullet)) return bullet;
  for (const re of FIRM_MATCHERS) {
    if (re.test(bullet)) return `${bullet} ${AMLAW_LABEL}`;
  }
  return bullet;
}

/** Cap to the top bullets (by backend priority order) and add Am Law labels. */
export function prepareHighlights(
  proofPoints: string[] | null | undefined,
  max: number = MAX_HIGHLIGHTS,
): string[] {
  if (!Array.isArray(proofPoints)) return [];
  return proofPoints.slice(0, max).map(decorateAmlawBullet);
}
